module.exports = __webpack_public_path__ + "assets/img/kv-c907c74b.jpg";